import React from 'react'
import style from '../card.module.css'

function Pratiksha() {
  return (
     <div  className={style.review_students}>
        <p>Thank you very much unacademy... Love your whole team...
            thank you very much for giving such a best quality education..
            I have no words to speak about this great platform..
            just say thank you... ❤
        </p>    
      <div className={style.review_students_name_start}>
          <div>
            <h2>Pratiksha Tupe</h2>  
          <p>7,528 learning minutes • NDA</p> 
          </div>
          <div>
            <h1>⭐⭐⭐⭐⭐</h1>  
            <p>1 month ago</p>  
          </div>
        </div>  
    </div>      
  )
}

export default Pratiksha